import styled, { css } from "styled-components";
import { buildColor, breakpoints } from "@tvg/design-system";
import { RaceCardContainer } from "../styled-components";

export const WillPaysHeader = styled.div`
  display: flex;
  width: 325px;
  height: 48px;
  background-color: ${buildColor("white", "900")};
  box-shadow: inset 0 -1px 0 ${buildColor("blue", "100")};
  align-items: center;
  padding: 14px 0 14px 12px;
`;

export const DropdownSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  gap: 10px;
  width: 324px;
  height: 66px;
  background-color: ${buildColor("blue_accent", "000")};
  border-bottom: 1px solid ${buildColor("blue", "100")};
`;

export const DropdownContainer = styled.div`
  width: 301px;
  height: 42px;
  background-color: ${buildColor("white", "900")};
  border: 1px solid ${buildColor("blue", "100")};
  box-shadow: 0 0 2px ${buildColor("blue", "000")};
  border-radius: 2px;
  align-self: stretch;
`;

export const ContentTable = styled.table`
  @media screen and ${breakpoints.tablet.max.sm} {
    width: 100%;
  }
`;

export const TR = styled.tr`
  @media screen and ${breakpoints.tablet.max.sm} {
    width: 100%;
  }
`;

export const TD = styled.td`
  align-items: center;
  gap: 8px;
  width: 162.5px;
  background-color: ${buildColor("white", "900")};
  border-width: 0 1px 1px 0;
  border-style: solid;
  border-color: ${buildColor("blue", "100")};
  font-family: Roboto-Regular, sans-serif;

  @media screen and ${breakpoints.tablet.max.sm} {
    width: auto;
  }
`;

export const PayoutCellContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const SaddleNumberContainer = styled.div`
  justify-content: column;
`;

export const WillPaysContainer = styled(RaceCardContainer)<{
  isEmptyMessage?: boolean;
}>`
  width: 325px;

  @media screen and ${breakpoints.tablet.max.sm} {
    width: 100%;
    margin-top: 0;
    border: none;
    ${({ isEmptyMessage }) =>
      isEmptyMessage &&
      css`
        justify-content: center;
        flex-grow: 1;
      `}
  }
`;
